import { Action } from './Action.js';
/**
 * @class Logout
 * @extends Action
 * @classdesc Действие Сменить пользователя
 * Сменить пользователя без завершения сессия, обновления страницы и перехода на стартовую мнемосхему
 * */
export class SwitchUser extends Action {
    execute() {
        const event = new CustomEvent('ms_message');
        event.data = { event: 'switchuser', username: this._username, password: this._password };

        if (this.prop_link["error"]) {
            event.data.callback = data => {
                if (data && data.code != 0 && (data.errorText || data.codeDescription))
                    this.prop_link["error"](data.errorText || data.codeDescription);
                else
                    this.prop_link["error"]("");
            }
        }

        window.dispatchEvent(event);
    }

    get Username() {
        return this._username || '';
    }
    set Username(value) {
        this._username = value;
    }


    get Password() {
        return this._password || '';
    }
    set Password(value) {
        this._password = value;
    }

    get Error() {
        return this._error;
    }
    set Error(value) {
        this._error = value;
    }
}